export default () => {
  const containers = document.querySelectorAll('.js-search');
  if (containers.length < 1) return;

  [...containers].forEach(container => {
    const header = document.querySelector('.c-page-header')
    const trigger = container.querySelector('.js-search-trigger');
    const target = container.querySelector('.js-search-target');
    const close = container.querySelector('.js-search-close');

    trigger.addEventListener('click', e => {
      target.classList.toggle('active');

      if (header) {
        header.classList.toggle('active');
      }
    });

    close.addEventListener('click', e => {
      if (target.classList.contains('active')) target.classList.remove('active');

      if (header && header.classList.contains('active')) {
        setTimeout(() => {
          header.classList.toggle('active');
        }, 250);
      }
    });
  });
};


// WEBPACK FOOTER //
// ./src/js/modules/HeaderSearch.js